import Entity from '@mm/state/model/requestModels/Entity';

// We are extending the base class Entity wrong
// redefining a method with different params so ignore
//
// @ts-ignore
export default class PageEntity extends Entity {
  botId: number;
  pageGroupId: number;
  name: string;
  notes?: string;
  sortOrder: number;

  static make(
    botId: number,
    pageGroupId: number,
    name: string,
    notes: string,
    sortOrder: number,
  ) {
    return {
      ...super.make(),
      botId,
      pageGroupId,
      name,
      notes,
      sortOrder,
    };
  }
}
